import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=0d03e11f&scoped=true&"
import script from "./Attestation.vue?vue&type=script&lang=js&"
export * from "./Attestation.vue?vue&type=script&lang=js&"
import style0 from "./Attestation.vue?vue&type=style&index=0&id=0d03e11f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03e11f",
  null
  
)

export default component.exports